import { useState, useEffect } from 'react'
import api from '../api'

const useFetchSettings = ({ surveyToken, setSettings }) => {
  const [isFetching, setIsFetching] = useState(false)

  useEffect(() => {
    const fetchSettings = async () => {
      setIsFetching(true)
      try {
        const licenseSettings = await api.fetchSettings(surveyToken)
        const grouping_labels =
          JSON?.parse(licenseSettings)?.grouping_labels || []
        setSettings({ grouping_labels })
      } catch (error) {
        console.error(error)
      } finally {
        setIsFetching(false)
      }
    }
    if (surveyToken) {
      fetchSettings()
    }
  }, [surveyToken])

  return { isFetching }
}

export default useFetchSettings
